export class PaymentCancellationError extends Error {
  constructor() {
    super("Apple Pay payment was cancelled");
    this.name = "PaymentCancellationError";
  }
}

export class MerchantValidationError extends Error {
  constructor(message: string) {
    super(`Apple Pay merchant validation failed: ${message}`);
    this.name = "MerchantValidationError";
  }
}

export class PaymentAuthorizationError extends Error {
  constructor(message: string) {
    super(`Apple Pay payment authorization failed: ${message}`);
    this.name = "PaymentAuthorizationError";
  }
}
